import { ENDPOINTS } from '../constants';
import { apiGet } from '../apiHelpers';

export const apiCompany = companyId => async (dispatch, getState) => {
    if (!companyId) {
        return false;
    }
    dispatch(apiGet(ENDPOINTS.API.COMPANY, ['company', companyId]));
};
